var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-nav-thumbnails" },
    _vm._l(_vm.illustrations, function (illustration) {
      return _c(
        "figure",
        {
          key: illustration.id,
          staticClass: "c-thumb",
          class: {
            "is-active": _vm.activeIllustration === illustration.id,
            "has-focus":
              _vm.hasFocus === true && _vm.focusIds.includes(illustration.id),
          },
          attrs: { tabindex: "0" },
          on: {
            click: function ($event) {
              return _vm.setActiveIllustration(illustration.id)
            },
            keypress: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.setActiveIllustration(illustration.id)
            },
          },
        },
        [
          _c("responsive-image", {
            staticClass: "c-thumb__img",
            attrs: { id: illustration.image[0].id },
          }),
          _vm._v(" "),
          _c("figcaption", { staticClass: "c-thumb__caption" }, [
            _vm._v("\n      " + _vm._s(illustration.name) + "\n    "),
          ]),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }